export default "__VITE_ASSET__B354whJg__"